import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { ApplicationClientCommonModule, CommonUIModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { TransportActionBarComponent } from './component/transport-action-bar.component';
import { ActionsModule } from '../actions/actions.module';
import { MatMenuModule as MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    TransportActionBarComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    MatInputModule,
    MatTooltipModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ActionsModule,
    CommonUIModule,
    MatMenuModule
  ],
  exports: [
    TransportActionBarComponent
  ]
})
export class TransportActionBarModule { }
